import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { forkJoin } from 'rxjs';
import {
  getStatusSubscription,
  getSupplySubscription,
} from '../event-store-service';
import {
  DataResponse,
  StatusResult,
  SupplyResult,
} from '@block-explorer/entities';
import { ErrorMessages } from '../../domain/error-messages';
import { cacheServiceContext } from '../cache-service';
import { useLocation } from 'react-router';
import { useThrottle } from './use-throttle';

export const useSyncGlobalStateOnRouteChange = () => {
  const { pathname } = useLocation();
  const [lastFetchTime, setLastFetchTime] = useState(0);
  const { setGlobalState } = useContext(cacheServiceContext);

  const staleTime = parseFloat(config.block_time) * 1000;

  const syncGlobalStateWithBackend = () => {
    forkJoin<[DataResponse<StatusResult>, DataResponse<SupplyResult>]>([
      getStatusSubscription({}),
      getSupplySubscription({}),
    ]).subscribe(
      ([status, supply]) => {
        const statusData = status.data ?? null;
        const supplyData = supply.data ?? null;

        const newState = {
          status: { data: statusData as StatusResult, error: null },
          supply: { data: supplyData as SupplyResult, error: null },
        };

        setGlobalState((state) => {
          return {
            ...state,
            ...newState,
          };
        });
        setLastFetchTime(new Date().getTime());
      },
      (err) => {
        setGlobalState((prevState) => {
          return {
            status: {
              data:
                prevState && prevState.status.data !== null
                  ? prevState.status.data
                  : null,
              error: ErrorMessages.DefaulRpcErrorMessage as string,
            },
            supply: {
              data:
                prevState && prevState.supply.data !== null
                  ? prevState.supply.data
                  : null,
              error: ErrorMessages.DefaulRpcErrorMessage as string,
            },
          };
        });
      }
    );
  };

  useThrottle(
    {
      staleTime,
      lastFetchTime,
      callback: syncGlobalStateWithBackend,
    },
    [pathname]
  );
};
